<template>
    <div class="table-corner mb-3">
        <b-card no-body>
            <b-card-header header-tag="header" role="tab" class="p-0" :style="styleVariant">
                <b-button v-b-toggle="'inbox-item-' + model.id" class="filter" variant="white" block href="#">
                    <b-row class="mt-2">
                        <b-col cols="10" lg="11">
                            <AppItemInbox :model="model" />
                        </b-col>
                        <b-col cols="2" lg="1">
                            <span class="d-lg-none d-block">
                                <b-icon-chevron-up style="margin-top:40px;margin-right:-10px" class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down style="margin-top:40px;margin-right:-10px" class="float-right chevron-down"></b-icon-chevron-down>
                            </span>
                            <span class="d-none d-lg-block">
                                <b-icon-chevron-up class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
                            </span>
                        </b-col>
                    </b-row>
                </b-button>
            </b-card-header>
            <b-collapse :id="'inbox-item-' + model.id" role="tabpanel">
                <b-card-body>
                    <AppItemDetailInbox :entityName="model.approvalType.name" :approvalStatus="model.status" :documentId="model.documentId" />
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>
<style lang="scss" scoped>
	.p-value {
        padding-top: calc(0.375rem + 1px);
        padding-bottom: calc(0.375rem + 1px);
    }
    .btn.not-collapsed .chevron-down {
        display: inline;
    }

    .btn.not-collapsed .chevron-right {
        display: none;
    }

    .btn.collapsed .chevron-right {
        display: inline;
    }

    .btn.collapsed .chevron-down {
        display: none;
    }
</style>
<script>
import AppItemInbox from '@/components/AppItemInbox';
import AppItemDetailInbox from '@/components/AppItemDetailInbox';

export default {
    components : {AppItemInbox,AppItemDetailInbox},
    props: ["model"],
    data() {
        return {}
    },
    methods : {
        
    },
    mounted() {
        
    },
    computed: {
        styleVariant() {
            if (this.model.status == 'REQUEST FOR REVISION') {
                return 'border-left: solid 4px #ffc107';
            }
            return 'border-left: solid 4px #007bff';
        },
    }
}
</script>